// extracted by mini-css-extract-plugin
module.exports = {"form":"InsuranceNumberForm_form__ERYsy","actions":"InsuranceNumberForm_actions__1Tjk6","formField":"InsuranceNumberForm_formField__1nJ4x"};